import { render, staticRenderFns } from "./electric-list.vue?vue&type=template&id=d90a9826&scoped=true&"
import script from "./electric-list.vue?vue&type=script&lang=js&"
export * from "./electric-list.vue?vue&type=script&lang=js&"
import style0 from "./electric-list.vue?vue&type=style&index=0&id=d90a9826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90a9826",
  null
  
)

export default component.exports